
window.FacebookTimezones = [
  {
    name: "UNKNOWN",
    value: 0
  },
  {
    name: "AMERICA/LOS ANGELES",
    value: 1
  },
  {
    name: "AMERICA/DENVER",
    value: 2
  },
  {
    name: "PACIFIC/HONOLULU",
    value: 3
  },
  {
    name: "AMERICA/ANCHORAGE",
    value: 4
  },
  {
    name: "AMERICA/PHOENIX",
    value: 5
  },
  {
    name: "AMERICA/CHICAGO",
    value: 6
  },
  {
    name: "AMERICA/NEW YORK",
    value: 7
  },
  {
    name: "ASIA/DUBAI",
    value: 8
  },
  {
    name: "AMERICA/ARGENTINA SAN LUIS",
    value: 9
  },
  {
    name: "AMERICA/ARGENTINA BUENOS AIRES",
    value: 10
  },
  {
    name: "AMERICA/ARGENTINA SALTA",
    value: 11
  },
  {
    name: "EUROPE/VIENNA",
    value: 12
  },
  {
    name: "AUSTRALIA PERTH",
    value: 13
  },
  {
    name: "AUSTRALIA BROKEN HILL",
    value: 14
  },
  {
    name: "AUSTRALIA SYDNEY",
    value: 15
  },
  {
    name: "EUROPE/SARAJEVO",
    value: 16
  },
  {
    name: "ASIA/DHAKA",
    value: 17
  },
  {
    name: "EUROPE/BRUSSELS",
    value: 18
  },
  {
    name: "EUROPE/SOFIA",
    value: 19
  },
  {
    name: "ASIA/BAHRAIN",
    value: 20
  },
  {
    name: "AMERICA/LA PAZ",
    value: 21
  },
  {
    name: "AMERICA/NORONHA",
    value: 22
  },
  {
    name: "AMERICA/CAMPO GRANDE",
    value: 23
  },
  {
    name: "AMERICA/BELEM",
    value: 24
  },
  {
    name: "AMERICA/SAO PAULO",
    value: 25
  },
  {
    name: "AMERICA/NASSAU",
    value: 26
  },
  {
    name: "AMERICA/DAWSON",
    value: 27
  },
  {
    name: "AMERICA/VANCOUVER",
    value: 28
  },
  {
    name: "AMERICA/DAWSON CREEK",
    value: 29
  },
  {
    name: "AMERICA/EDMONTON",
    value: 30
  },
  {
    name: "AMERICA/RAINY RIVER",
    value: 31
  },
  {
    name: "AMERICA/REGINA",
    value: 32
  },
  {
    name: "AMERICA/ATIKOKAN",
    value: 33
  },
  {
    name: "AMERICA/IQALUIT",
    value: 34
  },
  {
    name: "AMERICA/TORONTO",
    value: 35
  },
  {
    name: "AMERICA/BLANC SABLON",
    value: 36
  },
  {
    name: "AMERICA/HALIFAX",
    value: 37
  },
  {
    name: "AMERICA/ST JOHNS",
    value: 38
  },
  {
    name: "EUROPE/ZURICH",
    value: 39
  },
  {
    name: "PACIFIC/EASTER",
    value: 40
  },
  {
    name: "AMERICA/SANTIAGO",
    value: 41
  },
  {
    name: "ASIA/SHANGHAI",
    value: 42
  },
  {
    name: "AMERICA/BOGOTA",
    value: 43
  },
  {
    name: "AMERICA/COSTA RICA",
    value: 44
  },
  {
    name: "ASIA/NICOSIA",
    value: 45
  },
  {
    name: "EUROPE/PRAGUE",
    value: 46
  },
  {
    name: "EUROPE/BERLIN",
    value: 47
  },
  {
    name: "EUROPE/COPENHAGEN",
    value: 48
  },
  {
    name: "AMERICA/SANTO DOMINGO",
    value: 49
  },
  {
    name: "PACIFIC/GALAPAGOS",
    value: 50
  },
  {
    name: "AMERICA/GUAYAQUIL",
    value: 51
  },
  {
    name: "EUROPE/TALLINN",
    value: 52
  },
  {
    name: "AFRICA/CAIRO",
    value: 53
  },
  {
    name: "ATLANTIC CANARY",
    value: 54
  },
  {
    name: "EUROPE/MADRID",
    value: 55
  },
  {
    name: "EUROPE/HELSINKI",
    value: 56
  },
  {
    name: "EUROPE/PARIS",
    value: 57
  },
  {
    name: "EUROPE/LONDON",
    value: 58
  },
  {
    name: "AFRICA/ACCRA",
    value: 59
  },
  {
    name: "EUROPE/ATHENS",
    value: 60
  },
  {
    name: "AMERICA/GUATEMALA",
    value: 61
  },
  {
    name: "ASIA/HONG KONG",
    value: 62
  },
  {
    name: "AMERICA/TEGUCIGALPA",
    value: 63
  },
  {
    name: "EUROPE/ZAGREB",
    value: 64
  },
  {
    name: "EUROPE/BUDAPEST",
    value: 65
  },
  {
    name: "ASIA/JAKARTA",
    value: 66
  },
  {
    name: "ASIA/MAKASSAR",
    value: 67
  },
  {
    name: "ASIA/JAYAPURA",
    value: 68
  },
  {
    name: "EUROPE/DUBLIN",
    value: 69
  },
  {
    name: "ASIA/JERUSALEM",
    value: 70
  },
  {
    name: "ASIA/KOLKATA",
    value: 71
  },
  {
    name: "ASIA/BAGHDAD",
    value: 72
  },
  {
    name: "ATLANTIC REYKJAVIK",
    value: 73
  },
  {
    name: "EUROPE/ROME",
    value: 74
  },
  {
    name: "AMERICA/JAMAICA",
    value: 75
  },
  {
    name: "ASIA/AMMAN",
    value: 76
  },
  {
    name: "ASIA/TOKYO",
    value: 77
  },
  {
    name: "AFRICA/NAIROBI",
    value: 78
  },
  {
    name: "ASIA/SEOUL",
    value: 79
  },
  {
    name: "ASIA/KUWAIT",
    value: 80
  },
  {
    name: "ASIA/BEIRUT",
    value: 81
  },
  {
    name: "ASIA/COLOMBO",
    value: 82
  },
  {
    name: "EUROPE/VILNIUS",
    value: 83
  },
  {
    name: "EUROPE/LUXEMBOURG",
    value: 84
  },
  {
    name: "EUROPE/RIGA",
    value: 85
  },
  {
    name: "AFRICA/CASABLANCA",
    value: 86
  },
  {
    name: "EUROPE/SKOPJE",
    value: 87
  },
  {
    name: "EUROPE/MALTA",
    value: 88
  },
  {
    name: "INDIAN/MAURITIUS",
    value: 89
  },
  {
    name: "INDIAN/MALDIVES",
    value: 90
  },
  {
    name: "AMERICA/TIJUANA",
    value: 91
  },
  {
    name: "AMERICA/HERMOSILLO",
    value: 92
  },
  {
    name: "AMERICA/MAZATLAN",
    value: 93
  },
  {
    name: "AMERICA/MEXICO CITY",
    value: 94
  },
  {
    name: "ASIA/KUALA LUMPUR",
    value: 95
  },
  {
    name: "AFRICA/LAGOS",
    value: 96
  },
  {
    name: "AMERICA/MANAGUA",
    value: 97
  },
  {
    name: "EUROPE/AMSTERDAM",
    value: 98
  },
  {
    name: "EUROPE/OSLO",
    value: 99
  },
  {
    name: "PACIFIC/AUCKLAND",
    value: 100
  },
  {
    name: "ASIA/MUSCAT",
    value: 101
  },
  {
    name: "AMERICA/PANAMA",
    value: 102
  },
  {
    name: "AMERICA/LIMA",
    value: 103
  },
  {
    name: "ASIA/MANILA",
    value: 104
  },
  {
    name: "ASIA/KARACHI",
    value: 105
  },
  {
    name: "EUROPE/WARSAW",
    value: 106
  },
  {
    name: "AMERICA/PUERTO RICO",
    value: 107
  },
  {
    name: "ASIA/GAZA",
    value: 108
  },
  {
    name: "ATLANTIC AZORES",
    value: 109
  },
  {
    name: "EUROPE/LISBON",
    value: 110
  },
  {
    name: "AMERICA/ASUNCION",
    value: 111
  },
  {
    name: "ASIA/QATAR",
    value: 112
  },
  {
    name: "EUROPE/BUCHAREST",
    value: 113
  },
  {
    name: "EUROPE/BELGRADE",
    value: 114
  },
  {
    name: "EUROPE/KALININGRAD",
    value: 115
  },
  {
    name: "EUROPE/MOSCOW",
    value: 116
  },
  {
    name: "EUROPE/SAMARA",
    value: 117
  },
  {
    name: "ASIA/YEKATERINBURG",
    value: 118
  },
  {
    name: "ASIA/OMSK",
    value: 119
  },
  {
    name: "ASIA/KRASNOYARSK",
    value: 120
  },
  {
    name: "ASIA/IRKUTSK",
    value: 121
  },
  {
    name: "ASIA/YAKUTSK",
    value: 122
  },
  {
    name: "ASIA/VLADIVOSTOK",
    value: 123
  },
  {
    name: "ASIA/MAGADAN",
    value: 124
  },
  {
    name: "ASIA/KAMCHATKA",
    value: 125
  },
  {
    name: "ASIA/RIYADH",
    value: 126
  },
  {
    name: "EUROPE/STOCKHOLM",
    value: 127
  },
  {
    name: "ASIA/SINGAPORE",
    value: 128
  },
  {
    name: "EUROPE/LJUBLJANA",
    value: 129
  },
  {
    name: "EUROPE/BRATISLAVA",
    value: 130
  },
  {
    name: "AMERICA/EL SALVADOR",
    value: 131
  },
  {
    name: "ASIA/BANGKOK",
    value: 132
  },
  {
    name: "AFRICA/TUNIS",
    value: 133
  },
  {
    name: "EUROPE/ISTANBUL",
    value: 134
  },
  {
    name: "AMERICA/PORT OF SPAIN",
    value: 135
  },
  {
    name: "ASIA/TAIPEI",
    value: 136
  },
  {
    name: "EUROPE/KIEV",
    value: 137
  },
  {
    name: "AMERICA/MONTEVIDEO",
    value: 138
  },
  {
    name: "AMERICA/CARACAS",
    value: 139
  },
  {
    name: "ASIA/HO CHI MINH",
    value: 140
  },
  {
    name: "AFRICA/JOHANNESBURG",
    value: 141
  },
  {
    name: "NUM/TIMEZONES",
    value: 142
  }
];